jq2 = jQuery.noConflict();

jq2(function( $ ) {

    $('.flexslider').flexslider({
        animation: "slide",
        controlNav: false,
        directionNav: false,
        touch: false,
        keyboard: false,
        direction: "vertical",
        slideshowSpeed: 3000
    });

    if($('.instruction__video track').length !== 0) {

        let videoElement = document.getElementsByClassName('instruction__video');
        let textTrack = videoElement[0].textTracks;
        let subtitlesToggleButton = document.getElementById('toggle-subtitles');

        textTrack.addEventListener("change", (event) => {
            if (textTrack[0].mode === 'hidden' || textTrack[0].mode === 'disabled') {
                subtitlesToggleButton.classList.remove("show");
            } else {
                subtitlesToggleButton.classList.add("show");
            }
        });

        subtitlesToggleButton.addEventListener("click", function(event) {
            event.preventDefault();

            if(textTrack[0].mode === 'hidden' || textTrack[0].mode === 'disabled') {
                textTrack[0].mode = 'showing';
                videoElement[0].play();
            } else {
                textTrack[0].mode = 'hidden';
            }
        });
    }

});
